export default __webpack_public_path__ + "static/island-life-mobile-c681686903c0b62c3101a312d52e735a.webp";